import { render, staticRenderFns } from "./uservisitrecords-add-or-update.vue?vue&type=template&id=ed36b2ea&"
import script from "./uservisitrecords-add-or-update.vue?vue&type=script&lang=js&"
export * from "./uservisitrecords-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports